export default function setQueryStringParameter(key: string, value: string | null | undefined, url?: string | null) {
	let newUrl = url || window.location.href;

	const re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi');

	if (!re.test(newUrl)) {
		if (value == null) {
			return newUrl;
		}

		const separator = newUrl.indexOf('?') !== -1 ? '&' : '?';

		const hash: (string | null | undefined)[] = newUrl.split('#');

		const hashZero = hash[0];

		if (hashZero) {
			newUrl = hashZero + separator + key + '=' + encodeURIComponent(value);
		}

		const hashOne = hash[1];

		if (typeof hashOne !== 'undefined' && hashOne !== null) {
			newUrl += '#' + hashOne;
		}

		return newUrl;
	}

	if (typeof value !== 'undefined' && value !== null) {
		return newUrl.replace(re, '$1' + key + '=' + encodeURIComponent(value) + '$2$3');
	}

	const hashNew = newUrl.split('#');

	newUrl = hashNew[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
	newUrl += hashNew[1] ? '#' + hashNew[1] : ``;
	history.replaceState(undefined, '', newUrl);

	return newUrl;
}
